import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter
} from '@angular/core';

import {AuthentificationService} from './authentification.service';

const MENU_ITEMS = [
    {
        title: 'ACCUEIL',
        ico_url: './img/ico_accueil.png',
        link: "/dashboard",
        children: <any>[],
    },
    {
        title: 'ARTICLES',
        ico_url: './img/ico_articles.png',
        link: '/products-list',
        children: [
            {
                title: 'Gestion catégories',
                link: "/products-category"
            },
            {
                title: 'Liste articles',
                link: "/products-list"
            },
            {
                title: 'Création article',
                link: "/product-insert"
            },
            {
                title: 'Importation articles',
                link: "/import-items"
            }
        ],
    },
    {
        title: 'ORDRE DE SORTIE',
        ico_url: './img/ico_fournisseurs.png',
        link: '/release-order/transfer',
        children: [
            {
                title: 'Transfert',
                link: "/release-order/transfer"
            },
            {
                title: 'Réservation',
                link: "/release-order/reservation"
            },
            {
                title: 'Perte - casse - péremption',
                link: "/release-order/loss-breakage-lapsing"
            },
            {
                title: 'Expo - salon - démo',
                link: "/release-order/show"
            },
        ],
    },
    {
        title: 'GESTION STOCKS',
        ico_url: './img/ico_fournisseurs.png',
        link: '/initial-stock',
        children: [
            {
                title: 'Stock initial',
                link: "/initial-stock"
                //                link: "/receipt-stock_2"
            },
            {
                title: 'Entrée stocks',
                link: "/enter-bcf"
            },
            {
                title: 'Sortie stocks',
                link: "/article-release"
            },
            {
                title: 'Etat stocks',
                //                link: "admin/stock-availibility"
                link: "/stock-status"
            },
            {
                title: 'Liste bordereaux',
                link: "/docket-history"
            },
        ],
    },
    {
        title: 'INVENTAIRE',
        ico_url: './img/ico_stock.png',
        link: "/inventories",
        children: [
            {
                title: 'Gestion inventaire',
                link: "/inventories"
            },
            {
                title: 'Saisie inventaire',
                link: "/inventory-capture"
            },
            {
                title: 'Analyse inventaire',
                link: "/inventory-analysis"
            },
            {
                title: 'Rapports inventaire',
                link: "/inventory-reports"
            },
        ],
    },
    {
        title: 'ENTREPOTS',
        ico_url: './img/ico_stock.png',
        link: "/warehouses",
        children: [
            {
                title: 'Gestion entrepôts',
                link: "/warehouses"
            },
            {
                title: 'Gestion emplacements',
                link: "/location-manager"
            },
            {
                title: 'Placements',
                link: "/locations"
            },
        ],
    },
    {
        title: 'APPROVISIONNEMENTS',
        ico_url: './img/ico_fournisseurs.png',
        link: '/purchasing-list',
        children: [
            {
                title: "Liste demande achat/transfert",
                link: "/purchasing-list"
            },
            {
                title: 'Création demande d\'achat',
                link: "/purchasing-order"
            },
            {
                title: 'Création demande de transfert',
                link: "/transfer-request"
            },
            {
                title: 'Gestion fournisseurs',
                link: "/suppliers"
            },
            {
                title: 'Bon de commande FRNS',
                link: "/bcf"
            },
            {
                title: 'Reste à livrer FRNS',
                link: "/remains-to-deliver-supplier"
            },
            {
                title: 'Bon de retour FRNS',
                link: "/return-from-suppliers"
            },
        ],
    },
    {
        title: 'CLIENTS',
        ico_url: './img/ico_client.png',
        link: "/clients",
        children: [
            {
                title: 'Gestion clients',
                link: "/clients"
            },
            {
                title: 'Bon de commande Clients',
                link: "/order-from-clients"
            },
            {
                title: 'Reste à livrer Clients',
                link: "/remains-to-deliver"
            },
            {
                title: 'Bon de retour Clients',
                link: "/return-from-clients"
            },
        ],
    },
    {
        title: 'ANALYSES & RAPPORTS',
        ico_url: './img/ico_stats.png',
        link: "incidents-report",
        children: [
            {
                title: 'Rapports incidents',
                link: "incidents-report"
            },
            {
                title: 'Evaluation stocks',
                link: "stock-assessment"
            },
            {
                title: 'Statistiques',
                link: "statistics"
            },
            {
                title: 'Indicateurs de performance',
                link: "performance-indicators"
            },
        ],
    },
    {
        title: "CENTRE D' AIDE",
        ico_url: './img/ico_aide.png',
        link: "help",
        children: <any>[],
    },
    {
        title: 'UTILISATEUR',
        ico_url: './img/ico_accueil.png',
        link: 'actions',
        children: [
            {
                title: 'Historique des actions',
                link: "actions"
            },
            {
                title: 'Administrateur',
                link: "admin"

            },
        ],
    }
];


@Component({
    selector: 'left-menu',
    styleUrls: ['./styles/left-menu.component.css'],
    templateUrl: './templates/left-menu.component.html',
    providers: [AuthentificationService]
})


export class LeftMenuComponent {
    name = 'Left Menu';
    @Input() current_item: number = 0;
    @Input() selected: number = -1;
    menu_items = MENU_ITEMS;


    @Output() changed = new EventEmitter();

    //@Input() temp: string;// = "none";
    constructor(private authentification_service: AuthentificationService) {
    }

    toggle(idx: number, item: any): void {
        this.selected = -1;
        this.GetLink(item);
        //this.app_component.valTest = "";
        this.changed.emit('none');
        if (this.current_item === idx) {
            // Folding
            this.current_item = -1;
            //console.log("=");
        } else {
            // Expanding
            //console.log("!=");
            this.current_item = idx;
        }
        //console.log(this.current_item);
    };

    IsUserLogOut(action: string): void {
        //console.log(action);
        if (action === "authentification") {
            //LOGout
            this.authentification_service.LogOut().then(result => {console.log(result)});
        }
    }

    GetLink(item: any): void {

        for (let i = 0; i < item.children.length; i++) {
            if (item.link == item.children[i].link) {
                this.selected = i;
            }
        }
    }


    SetCurrentSubItem(index: number): void {
        this.selected = index;
    }

    Test(sub_item: any): void {
        console.log(sub_item);
    }


    ngOnInit(): void {

    }

}



// WEBPACK FOOTER //
// ./src/app/left-menu.component.ts